import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import { Icon } from "@iconify/react/dist/iconify.js";
import toast from "react-hot-toast";
import dayjs from "dayjs";
const TicketsManagement = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);

    const [showPriceModal, setShowPriceModal] = useState(false);
    const [ticketData, setTicketData] = useState({
        name: "",
        date: "",
        adultPrice: "",
        childPrice: ""
    });


    const navratriStartDate = dayjs("2025-09-22");

    const dayOptions = Array.from({ length: 9 }, (_, index) => {
        const day = `Day ${index + 1}`;
        const date = navratriStartDate.add(index, "day").format("YYYY-MM-DD");
        const label = `${day} - ${dayjs(date).format("DD MMM YYYY")}`;
        return {
            label,
            name: day,
            date,
        };
    });

    console.log("Options",dayOptions)


    const handleTicketChange = (e) => {
        const { name, value } = e.target;
        setTicketData({ ...ticketData, [name]: value });
    };







    const handleSubmitTicketPrice = async () => {
        try {
            if (!ticketData.name || !ticketData.date || !ticketData.adultPrice || !ticketData.childPrice) {
                toast.error("Please fill all fields.");
                return;
            }

            setIsSubmitting(true);

            const apiEndpoint = isEditing ? "/update-ticket-pricing" : "/pricing-management";

            const payload = {
                name: ticketData.name,
                date: ticketData.date,
                adultPrice: ticketData.adultPrice,
                childPrice: ticketData.childPrice,
                ...(isEditing && { id: editId })
            };

            const response = await axios.post(`${BaseUrl}${apiEndpoint}`, payload);

            if (response.status === 200) {
                toast.success(isEditing ? "Ticket price updated successfully!" : "Ticket price added successfully!");

                // Reset
                setShowPriceModal(false);
                setIsEditing(false);
                setEditId(null);
                setTicketData({
                    name: "",
                    date: "",
                    adultPrice: "",
                    childPrice: ""
                });

                getGuardDetails(); // refresh table
            }
        } catch (error) {
            toast.error("Failed to submit ticket price.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleDaySelect = (e) => {
        const selected = dayOptions.find((d) => d.label === e.target.value);
        if (selected) {
            setTicketData({
                ...ticketData,
                name: selected.name,
                date: selected.date,
            });
        }
    };




    const [guards, setGuards] = useState([]);





    const [isLoading, setIsLoading] = useState(false);


    const getGuardDetails = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post(`${BaseUrl}/get-pricing-management`
            );
            if (response.status === 200) {
                setGuards(response?.data?.existingRecords || []);
            }
        } catch (error) {
            console.log(error);
            setGuards([]);
        } finally {
            setIsLoading(false);
        }
    };

    console.log("Guard Data", guards)

    useEffect(() => {
        getGuardDetails();
    }, []);
    const handleEditClick = async (item) => {
        console.log("Edit ::", item);

    }
    const handleDeleteClick = async (item) => {
        const toastId = toast.loading("Deleting Ticket Data...");
        try {
            console.log(item);

            let body = { id: item._id }
            let response = await axios.post(`${BaseUrl}/delete-ticket-record`, body);
            if (response.status === 200) {
                toast.success("Ticket Data deleted successfully", { id: toastId })
                getGuardDetails()
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong", { id: toastId });

            console.log(error);

        }
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const selectedDayLabel = dayOptions.find(
        (d) => d.name === ticketData.name && dayjs(d.date).format("YYYY-MM-DD") === dayjs(ticketData.date).format("YYYY-MM-DD")
    )?.label || "";
    const ticketPricingList = guards?.map((item) => ({
        name: item?.name,
        date: item?.date,
    }));


    const addedDayNames = ticketPricingList?.map((item) => item?.name);


    const filteredBooking = guards?.filter((guards) => {
        const search = searchTerm?.toLowerCase();

        return Object.entries(guards)
            .filter(([key]) =>
                ["name", "date", "adultPrice", "childPrice"].includes(key)
            )
            .some(([_, value]) =>
                String(value)?.toLowerCase().includes(search)
            );
    });


    return (
        <MasterLayout>
            <Breadcrumb title="Tickets Management" />

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap" }}>
                        {/* <h5 className="card-title mb-0">Manage Tickets</h5> */}

                        <form className="navbar-search d-flex align-items-center gap-2">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto form-control"
                                name="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>


                        <button
                            type="button"
                            className="btn btn-primary-600 radius-8 px-20 py-11"
                            onClick={() => setShowPriceModal(true)}
                        >
                            + Add Ticket Price
                        </button>




                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            {isLoading ? (
                                <div className="text-center py-40">
                                    <div className="spinner-border text-primary" role="status" />
                                </div>
                            ) : filteredBooking?.length === 0 ? (
                                <div className="text-center py-40 text-muted fw-medium">No tickets data found.</div>
                            ) : (
                                <table className="table basic-border-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>No.</th>
                                            <th>Date</th>

                                            <th>Day</th>
                                            <th>Adult Price</th>
                                            <th>Child Price</th>
                                            <th>Action</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBooking
                                            ?.slice() // Create a shallow copy to avoid mutating the original
                                            .sort((a, b) => new Date(a.date) - new Date(b.date)) // Sort ascending
                                            .map((items, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{formatDate(items.date)}</td>

                                                    <td>{items?.name}</td>

                                                    <td>₹{items.adultPrice?.toLocaleString("en-IN")}</td>
                                                    <td>₹{items.childPrice?.toLocaleString("en-IN")}</td>
                                                    <td className="text-start">
                                                        <div className="d-flex align-items-start gap-10 justify-content-start">

                                                            <button
                                                                type="button"
                                                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                onClick={() => {
                                                                    setTicketData({
                                                                        name: items.name,
                                                                        date: dayjs(items.date).format("YYYY-MM-DD"),
                                                                        adultPrice: items.adultPrice,
                                                                        childPrice: items.childPrice,
                                                                    });
                                                                    setIsEditing(true);
                                                                    setEditId(items._id);
                                                                    setShowPriceModal(true);
                                                                }}
                                                            >
                                                                <Icon icon="lucide:edit" className="menu-icon" />
                                                            </button>

                                                            <button
                                                                onClick={() => handleDeleteClick(items)}
                                                                type="button"

                                                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                            >
                                                                <Icon
                                                                    icon="fluent:delete-24-regular"
                                                                    className="menu-icon"
                                                                />
                                                            </button>
                                                        </div>
                                                    </td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            )}

                        </div>
                    </div>
                </div>
            </div>


            {showPriceModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-md modal-dialog-centered" style={{ zIndex: 11122 }}>
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-header py-16 px-24 border-bottom">
                                <h5 className="modal-title">  {isEditing ? "Edit Ticket Price" : "Add Ticket Price"}</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowPriceModal(false)}
                                />
                            </div>

                            <div className="modal-body p-24">
                                {/* <div className="mb-3">
                                    <label className="form-label fw-semibold">Select Day</label>
                                    <select
                                        className="form-select"
                                        value={selectedDayLabel}
                                        onChange={handleDaySelect}
                                    >
                                        <option value="">-- Select --</option>
                                        {dayOptions.map((day) => (
                                            <option key={day.name} value={day.label}>
                                                {day.label}
                                            </option>
                                        ))}
                                    </select>
                                </div> */}

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Select Day</label>
                                    <select
                                        className="form-select"
                                        value={selectedDayLabel}
                                        onChange={handleDaySelect}
                                    >
                                        <option value="">-- Select --</option>
                                        {dayOptions
                                            .filter((day) => {
                                                if (isEditing && day.name === ticketData.name) return true;
                                                return !addedDayNames.includes(day.name);
                                            })
                                            .map((day) => (
                                                <option key={day.name} value={day.label}>
                                                    {day.label}
                                                </option>
                                            ))}
                                    </select>
                                </div>


                                {/* <div className="mb-3">
                                    <label className="form-label fw-semibold">Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        name="date"
                                        value={ticketData.date}
                                        onChange={handleTicketChange}
                                    />
                                </div> */}

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Adult Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="adultPrice"
                                        value={ticketData.adultPrice}
                                        onChange={handleTicketChange}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Child Price</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="childPrice"
                                        value={ticketData.childPrice}
                                        onChange={handleTicketChange}
                                    />
                                </div>

                                <div className="d-flex justify-content-end gap-3">
                                    <button
                                        type="button"
                                        className="btn border border-danger text-danger px-32 py-8"
                                        onClick={() => {


                                            setShowPriceModal(false);
                                            setIsEditing(false);
                                            setEditId(null);
                                            setTicketData({ name: "", date: "", adultPrice: "", childPrice: "" });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary px-32 py-8"
                                        onClick={handleSubmitTicketPrice}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                {isEditing ? "Updating..." : "Saving..."}
                                            </>
                                        ) : (
                                            isEditing ? "Update" : "Save"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
                </div>
            )}


        </MasterLayout>
    );
};

export default TicketsManagement;
